import { useQuery } from '@tanstack/react-query';
import { SyncTransactionsBidvVAEntity, BidvVirtualAccountService, SyncTransactionsBidvVADto } from 'services/openapi';

import { BidvVirtualAccountServiceQueryKeys } from '../constants';

type SyncTransactionsBidvVAQueryDTO = {
  endCode: string;
  requestBody: SyncTransactionsBidvVADto;
  enabled?: boolean;
};

export const useSyncTransactionsBidvVAQuery = (variables: SyncTransactionsBidvVAQueryDTO) => {
  const { enabled = true, endCode, requestBody } = variables;
  const queryKey = [BidvVirtualAccountServiceQueryKeys.SYNC_TRANSACTIONS, endCode, requestBody];

  const {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  } = useQuery<SyncTransactionsBidvVAEntity, Error>({
    queryKey,
    queryFn: () =>
      BidvVirtualAccountService.bidvVaControllerSyncTransactions(endCode, requestBody),
    retry: 0,
    refetchOnWindowFocus: false,
    keepPreviousData: true,
    enabled: enabled && !!endCode && !!requestBody,
  });

  return {
    isLoading,
    error,
    data,
    isError,
    isFetching,
    isLoadingError,
    refetch,
  };
};